import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "EmployeeCreate" }
const _hoisted_2 = { class: "EmployeeCreate__props" }
const _hoisted_3 = { class: "EmployeeCreate__tools" }

import { ref } from "vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { useRouter } from "vue-router";
import { useEmployeeStore } from "@/stores/employees";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import InnInput from "@/components/ds/input/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeCreate',
  setup(__props) {

const employeesStore = useEmployeeStore();
const uiStore = useUiStore();

const router = useRouter();
const name = ref("");
const email = ref("");

const createEmployee = () => {
    const employee = employeesStore.getNew();
    employee.name = name.value;
    employee.email = email.value;
    api.create(employee, "users").then((response) => {
        employee.id = response.id;
        employeesStore.create(employee);
        uiStore.message("Werknemer aangemaakt..");
        router.push({ name: "Employee", params: { id: employee.id } });
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InnInput, {
        modelValue: name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
        placeholder: "Naam van werknemer..."
      }, null, 8, ["modelValue"]),
      _createVNode(InnInput, {
        modelValue: email.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
        placeholder: "Email..."
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(IconButton, {
        disabled: name.value.length === 0,
        "icon-id": "plus",
        onClick: createEmployee
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Werknemer aanmaken ")
        ])),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})